import {LOCALES} from '../locales'
export default {
    [LOCALES.SPANISH]: {
        //main page
        

    }
}